import { getStoreBuilder, BareActionContext } from "vuex-typex";
import { ProductListState, RootState } from "Store/types";
import { State } from "vuex-class";
import { FilterItem } from "Models/FacetFilter/FilterItem";
import { ProductListPage } from "Models/Products/ProductListPage";

const initialProductListState: ProductListState = {
    error: false,
    isLoading: true,
    filterMap: {},
    query: undefined,
    productPage: undefined,
    productListPage: undefined,
}

const p = getStoreBuilder<RootState>().module("productList", initialProductListState);
var loadPromise: Promise<void>;
//Getters

//Mutations
function setLoading(state: ProductListState) {
    state.isLoading = true;
}
function setLoaded(state: ProductListState) {
    state.isLoading = false;
}
function queryUpdate(state: ProductListState, query: string) {
    state.query = query;
}
function productPageUpdate(state: ProductListState, page: string) {
    state.productPage = page;
}
function filterMapUpdate(state: ProductListState, object: { [key: string]: string[] }) {
    state.filterMap = object;
}
function setProductListPage(state: ProductListState, productListPage: ProductListPage) {
    state.productListPage = productListPage;
}
function clearFilterMap(state: ProductListState) {
    state.filterMap = {};
}
//Actions
async function updateQuery(context: BareActionContext<ProductListState, RootState>, items: FilterItem[]) {
    items.forEach((item) => {
        var stateItem = productList.state.filterMap[item.key];
        if (stateItem && !stateItem.includes(item.value)) {
            stateItem.push(item.value);
        }
        else {
            productList.state.filterMap[item.key] = new Array(item.value);
        }
    })
    productList.commitQueryUpdate(createQuery(productList.state.filterMap));
}
async function updateQueryReplaceValues(context: BareActionContext<ProductListState, RootState>, items: FilterItem[]) {
    items.forEach((item) => {
        productList.state.filterMap[item.key] = new Array(item.value);
    })
    productList.commitQueryUpdate(createQuery(productList.state.filterMap));
}

async function updateQueryRemoveValues(context: BareActionContext<ProductListState, RootState>, items: FilterItem[]) {
    items.forEach((item) => {
        productList.state.filterMap[item.key] = productList.state.filterMap[item.key].filter(a => a != item.value);
    })
    productList.commitQueryUpdate(createQuery(productList.state.filterMap));
}

async function updateProductListPage(context: BareActionContext<ProductListState, RootState>, allowRetry: boolean = true): Promise<void> {
    productList.commitSetLoading();

    // Get 'b2b-en', 'b2b-fr' or 'b2b-nl' based on website
    let languageSiteUrl = window.location.pathname.split('/')[1];

    // Build request url to DW api
    let requestUrl = `/${languageSiteUrl}/dwapi/asyncplp${context.state.productPage}${context.state.query}`;

    try {
        return new Promise((resolve, reject) => {
            $.ajax(`${requestUrl}`).then((res: ProductListPage) => {

                // check if res.Products is empty
                if (res && res.Products && res.Products.length > 0) {
                    productList.commitUpdateProductListPage(res);
                    productList.commitSetLoaded();
                    resolve();
                } else {
                    if (allowRetry) {
                        resolve(updateProductListPage(context, false));
                    } else {
                        reject('No products after retry');
                    }
                }
            }).catch(e => {
                console.log(e);
                reject(e);
            });
        });
    } catch (e) {
        console.log(e);
        return Promise.reject(e);
    }
}

async function updateProductListPagePorterBuilder(context: BareActionContext<ProductListState, RootState>, porterContact: string) {
    productList.commitSetLoading();
    // Get 'b2b-en', 'b2b-fr' or 'b2b-nl' based on website
    var languageSiteUrl = window.location.pathname.split('/')[1];

    // Build request url to DW api
    var requestUrl = `/${languageSiteUrl}/dwapi/asyncplp${context.state.productPage}${context.state.query}`;

    //if (!requestUrl.includes("porterNo")) {
    //    if (context.state.query == null || context.state.query === "") {
    //        requestUrl += "?porterNo=" + porterContact;
    //    } else {
    //        requestUrl += "&porterNo=" + porterContact;
    //    }
    //}

    try {
        $.ajax(`${requestUrl}`).then((res: ProductListPage) => {
            productList.commitUpdateProductListPage(res);
            productList.commitSetLoaded();
        });
    } catch (e) {
        console.log(e);

    }

}

async function updatePorterProductListPage(context: BareActionContext<ProductListState, RootState>) {
    productList.commitSetLoading();
    // Get 'b2b-en', 'b2b-fr' or 'b2b-nl' based on website
    var languageSiteUrl = window.location.pathname.split('/')[1];

    // Build request url to DW api
    var requestUrl = `/${languageSiteUrl}/dwapi/asyncporterplp${context.state.productPage}${context.state.query}`;
    try {
        $.ajax(`${requestUrl}`).then((res: ProductListPage) => {
            productList.commitUpdateProductListPage(res);
            productList.commitSetLoaded();
        });
    } catch (e) {
        console.log(e);

    }

}

async function clearFilters(context: BareActionContext<ProductListState, RootState>) {
    productList.commitClearFilterMap();
    productList.commitQueryUpdate("");
}

async function setProductQueryFromUrl(context: BareActionContext<ProductListState, RootState>): Promise<void> {

    // if(loadPromise){
    //     return loadPromise;
    // }
    return loadPromise = new Promise((resolve) => {
        // Requested URL
        var url = new URL(window.location.href);

        // Use category to find products per default.
        var categoryUrl = "/" + url.pathname.split("/").pop();

        if (url.search.length > 0 || categoryUrl === "/products" || categoryUrl === "/artikels" || categoryUrl === "/articles") {
            // If searching, remove category - we want to search all products
            categoryUrl = ""
        }

        productList.commitProductPageUpdate(categoryUrl);

        // Get the current query string and build a map from it
        const urlParams = new URLSearchParams(window.location.search);
        const keys = Array.from(urlParams.keys());

        let params: { [key: string]: string[] } = {};
        keys.forEach(key => {
            let values: string[] = urlParams.get(key).split(",");
            params[key] = values;
        });

        productList.commitFilterMapUpdate(params);
        productList.commitQueryUpdate(createQuery(params));

        resolve();
    });
}


function createQuery(params: { [key: string]: string[] }) {
    //Build Query from parameters
    let query = params ? "?" : "";
    let i = 0;

    for (var param in params) {
        if (params[param].length > 0) {
            query += param;
            let valueString = "=";
            let encodedParams: string[] = new Array();
            params[param].forEach(a => encodedParams.push(encodeURIComponent(a)))
            valueString += encodedParams.join(",");
            valueString += "&";
            query += valueString;
        }
    }

    //Remove last char (&) from the query
    query = query.slice(0, -1);
    productList.commitQueryUpdate(query);
    return query;
}


//State
const stateGetter = p.state();

const productList = {
    //State
    get state() { return stateGetter() },

    //Getters

    //Mutations
    commitSetLoading: p.commit(setLoading),
    commitSetLoaded: p.commit(setLoaded),
    commitQueryUpdate: p.commit(queryUpdate),
    commitProductPageUpdate: p.commit(productPageUpdate),
    commitFilterMapUpdate: p.commit(filterMapUpdate),
    commitClearFilterMap: p.commit(clearFilterMap),
    commitUpdateProductListPage: p.commit(setProductListPage),
    //Actions
    dispatchUpdateProductListPage: p.dispatch(updateProductListPage),
    dispatchUpdateProductListPagePorterBuilder: p.dispatch(updateProductListPagePorterBuilder),
    dispatchUpdateQuery: p.dispatch(updateQuery),
    dispatchUpdateQueryReplaceValues: p.dispatch(updateQueryReplaceValues),
    dispatchUpdateQueryRemoveValues: p.dispatch(updateQueryRemoveValues),
    dispatchSetProductQueryFromUrl: p.dispatch(setProductQueryFromUrl),
    dispatchClearFilters: p.dispatch(clearFilters),


    //Actions Porter
    dispatchUpdatePorterProductListPage: p.dispatch(updatePorterProductListPage)


}
export default productList;